import React from 'react';
import { Text, Tooltip } from '@fluentui/react-components';
import { Info24Regular } from '@fluentui/react-icons';

// a shared component for field labels (Field title + tooltip) in the create/edit agent forms that includes a tooltip with more information about the field. used in multiple places in the forms so extracted to avoid duplication
interface AgentFieldLabelProps {
    label: string;
    tooltip: string;
    fieldLabelClassName: string;
    fieldNameClassName: string;
    tooltipIconClassName: string;
    tooltipContentClassName: string;
}

const AgentFieldLabel: React.FC<AgentFieldLabelProps> = ({
    label,
    tooltip,
    fieldLabelClassName,
    fieldNameClassName,
    tooltipIconClassName,
    tooltipContentClassName,
}) => {
    return (
        <div className={fieldLabelClassName}>
            <Text className={fieldNameClassName}>{label}</Text>
            <Tooltip
                relationship="label"
                positioning="after"
                content={<div className={tooltipContentClassName}>{tooltip}</div>}
            >
                <Info24Regular className={tooltipIconClassName} />
            </Tooltip>
        </div>
    );
};

export default AgentFieldLabel;
